<template>
  <div>
    <div
      v-if="!mobileBreakpoints()"
      class="elevation-0 mr-4 d-flex top-component-class margin-left-5"
      style="pointer-events: none"
    >
      <v-row class="mr-16 ml-6 mt-0 mb-0 pb-2 fill-height d-flex justify-space-between">
        <div
          class="d-flex flex-column"
          style="justify-content: end;"
        >
          <legends-button />

          <div class="mouse-coord">
            <span>
              <b>Lat:</b> {{ map.mouseCoord ? map.mouseCoord[1].toFixed(4) : '' }} - <b>Lon:</b> {{ map.mouseCoord ? map.mouseCoord[0].toFixed(4) : '' }}
            </span>
          </div>
        </div>
        <img
          v-if="(file_transfer.logoUrl != '')"
          id="customer-logo"
          class="mr-12"
          :src="file_transfer.logoUrl"
        >
      </v-row>
    </div>

    <!-- Solo per mobile -->
    <div
      v-else
      class="d-flex flex-column top-component-class"
    >
      <mobile-menu-button @openRangeDateMenu="openRangeDateMenu()" />
      <player
        v-if="checkShowPlayer()"
        :auto-open-range-date="wsServices.autoOpenRangeDate"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    LegendsButton: () => import('@/components/layout/LegendsButton.vue'),
    MobileMenuButton: () => import('@/components/layout/MobileMenuButton.vue'),
    Player: () => import('@/components/utils/Player.vue')
  },
  computed: {
    ...
    mapState(['map', 'file_transfer', 'wsServices'])
  },
  methods: {
    ...mapActions(['setAutoOpenRangeDate']),
    isLandscape() {
      return /Mobi|Android/i.test(navigator.userAgent) && window.innerHeight < window.innerWidth;
    },
    mobileBreakpoints() {
      return /Mobi|Android/i.test(navigator.userAgent) || this.isLandscape();
    },
    checkShowPlayer() {
      return this.mobileBreakpoints()
        && ['Real-Time', 'Archive', 'Forecast'].includes(this.$route.params.id)
        && this.wsServices.activeServices.length > 0;
    },
    async openRangeDateMenu() {
      await this.setAutoOpenRangeDate(true);
    }
  }
};
</script>

<style scoped>
#customer-logo {
  object-fit: contain;
  object-position: right bottom;
  max-width: 180px;
  max-height: 80px;
}
.top-component-class {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 2;
  pointer-events: none;
  touch-action: none;
}
.margin-left-5 {
  margin-left: 5em;
}

@media (max-device-width:599px), (max-device-height:599px) and (orientation: landscape){
  #customer-logo{
    position: fixed;
    top: 0;
    right: 0;
    max-width: 130px !important;
    max-height: 60px !important;
    margin: 12px 12px 0px 0px!important;
    padding: 0px!important;
  }
}
.white-bg {
  background-color: rgb(255, 255, 255, .85);
  min-height: 100%;
}
.transparent-bg {
  background-color: transparent;
  scrollbar-width: thin;
}
.mouse-coord{
  margin-top: 8px;
  max-height: fit-content;
  max-width: fit-content;
  border-radius: 4px;
  background-color: rgba(255,255,255, 0.8);
  padding: 4px 8px;
  width: 232px;
}
/* .top-component-class-variant {
  position: absolute;
  min-height: 8em;
  bottom: 0;
  z-index: 4;
  margin-left: 17.5em;
  box-shadow: inset 0 -50vh 9vh -44vh #000000 !important;
} */
</style>
